import {ZonasExclusionActions, ZonasExclusionActionTypes} from './zonas-exclusion.actions';
import {initialState, zonasExclusionAdapter, ZonasExclusionState} from './zonas-exclusion.state';

export function zonasExclusionReducer(
  state = initialState,
  action: ZonasExclusionActions
): ZonasExclusionState {
  switch (action.type) {
    // load
    case ZonasExclusionActionTypes.LOAD_REQUEST: {
      return {
        ...state,
        isLoading: true,
        error: null
      };
    }
    case ZonasExclusionActionTypes.LOAD_SUCCESS: {
      return zonasExclusionAdapter.addMany(action.payload.items, {
        ...state,
        isLoading: false,
        error: null
      });
    }
    case ZonasExclusionActionTypes.LOAD_FAILURE: {
      return {
        ...state,
        isLoading: false,
        error: action.payload.error
      };
    }
    // add
    case ZonasExclusionActionTypes.ADD_REQUEST: {
      return {
        ...state,
        isLoading: true,
        error: null
      };
    }
    case ZonasExclusionActionTypes.ADD_SUCCESS: {
      return zonasExclusionAdapter.addOne(action.payload.item, {
        ...state,
        isLoading: false,
        error: null
      });
    }
    case ZonasExclusionActionTypes.ADD_FAILURE: {
      return {
        ...state,
        isLoading: false,
        error: action.payload.error
      };
    }
    // change
    case ZonasExclusionActionTypes.CHANGE_REQUEST: {
      return {
        ...state,
        isLoading: true,
        error: null
      };
    }
    case ZonasExclusionActionTypes.CHANGE_SUCCESS: {
      return zonasExclusionAdapter.updateOne(action.payload.item, {
        ...state,
        isLoading: false,
        error: null
      });
    }
    case ZonasExclusionActionTypes.CHANGE_FAILURE: {
      return {
        ...state,
        isLoading: false,
        error: action.payload.error
      };
    }
    // delete
    case ZonasExclusionActionTypes.DELETE_REQUEST: {
      return {
        ...state,
        isLoading: true,
        error: null
      };
    }
    case ZonasExclusionActionTypes.DELETE_SUCCESS: {
      return zonasExclusionAdapter.removeOne(
        action.payload.item.zonaExclusionId,
        {
          ...state,
          isLoading: false,
          error: null
        }
      );
    }
    case ZonasExclusionActionTypes.DELETE_FAILURE: {
      return {
        ...state,
        isLoading: false,
        error: action.payload.error
      };
    }
    // default
    default: {
      return state;
    }
  }
}
